module.exports = __webpack_public_path__ + "static/media/cancel.57a5cd0a.svg";